;
export var messages = {
    GetMembership: 'Get Membership',
    UpgradeMembership: 'Upgrade Membership',
    Relevance: 'Relevance',
    HideRemix: 'Hide Remixes',
    SelectACategory: 'Select a category',
    SongVersion: 'Song Version',
    SelectGenre: 'Select Genre',
    SelectMood: 'Select Mood',
    SelectCategory: 'Select Category',
    Upgrade: 'Upgrade',
    Top10: 'Top 10',
    Submit: 'Submit',
    Shuffle: 'Shuffle',
    Hide: 'Hide',
    ViewAll: 'View All',
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    SelectADuration: 'Select a duration',
    All: 'All',
    Audio: 'Audio',
    Video: 'Video',
    Categories: 'Categories',
    YourCrate: 'Your Crate',
    EmptyCrate: 'Your Crate is empty',
    ClearAll: 'Clear All',
    DownloadBatch: 'Download Batch',
    NextSongs: 'Next Songs',
    CurrentSong: 'Current Song',
    Artists: 'Artists',
    Category: 'Category',
    Genre: 'Genre',
    Uploaded: 'Uploaded',
    BPM: 'BPM',
    Length: 'Length',
    HQStreaming: 'High Quality Audio Streaming',
    Home: 'Home',
    Support: 'Support',
    Contact: 'Contact',
    Logout: 'Logout',
    Fullscreen: 'Enter Fullscreen',
    ExitFullScreen: 'Exit Fullscreen',
    CustomerId: 'Customer ID',
    PlayAll: 'Play All',
    ShuffleAll: 'Shuffle All',
    ChooseCategory: 'Choose Category',
    ShowOnly: 'Show Only',
    to: 'to',
    Key: 'Key',
    SortBy: 'Sort By',
    Reset: 'Reset',
    DayMode: 'Day Mode',
    NightMode: 'Night Mode'
};
export function setMessages(m) {
    Object.keys(m).forEach(function (key) {
        messages[key] = m[key];
    });
}
//# sourceMappingURL=messages.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/messages.js
// module id = 52
// module chunks = 0